import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InfoComponent } from "./info.component";
import { InfoLayoutComponent } from "./info.layout";
import { InfoRoutingModule } from "./info-routing.module";
import { ThemeModule } from "../@theme/theme.module";
import { NbSpinnerModule, NbTabsetModule } from "@nebular/theme";

@NgModule({
    declarations: [InfoComponent, InfoLayoutComponent],
    imports: [
        CommonModule,
        InfoRoutingModule,
        ThemeModule,
        NbTabsetModule,
        NbSpinnerModule,
    ],
})
export class InfoModule {}
